import styled from "styled-components";

export const ControllerQrReEntryWrapper = styled.div`
  position: absolute;
  z-index: 100;
  background: #fff;
  width: 514px;
  height: 216px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  padding: 24px 15px;
  box-sizing: border-box;
`;

export const ControllerQrReEntryItemWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  gap: 10px 8px;
  margin-top: 10px;
`;

export const ControllerQrReEntryItem = styled.div<{ isCancel?: boolean }>`
  background: ${(p) => (p.isCancel ? "#fff" : "#f0f0f0")};
  color: ${(p) => (p.isCancel ? "#6436E7" : "#000")};
  width: 100%;
  height: 62px;
  border-radius: 8px;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > span {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    color: #808080;
  }
`;
